export default __webpack_public_path__ + "static/media/liveClassCounter.9b4e5985.svg";